import Icon from '../components/Icon.vue'

Icon.register({
  icicles: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M511.4 37.9l-87.5 467.7c-1.7 8.6-14 8.6-15.7 0l-66.7-363.8-45.8 172.5c-2.3 7.6-13 7.6-15.3 0l-34.1-133.4-46.5 196.9c-1.9 8.3-13.7 8.3-15.6 0l-44.2-187.3-36.4 124.1c-2.4 7.2-12.6 7.2-15.1 0l-87.1-273.4c-6.2-20.5 9.2-41.2 30.6-41.2h448c20 0 35.1 18.2 31.4 37.9z'
      }
    ]
  }
})
